export default {
    namespaced: true,
    state() {
        return {
            parcels: [],
            categories: [],
            parcel: window?.data?.order?.quote?.parcel,
            weight: undefined,
            height: undefined,
            width: undefined,
            length: undefined,
            subcategory: undefined,
            description: undefined,
        }
    },
    getters: {
        completed(state) {
            return !!state.weight && !!state.height && !!state.width && !!state.length && !!state.subcategory && !!state.description;
        },
        form(state) {
            return {
                id: state.parcel ? state.parcel.id : undefined,
                weight: state.weight,
                height: state.height,
                width: state.width,
                length: state.length,
                subcategory_id: state.subcategory.id,
                description: state.description,
            };
        },
    },
    actions: {
        loadParcels({commit}) {
            api.parcel.index().then(
                response => commit('setParcels', response.data.data)
            )
        },
        loadCategories({commit}) {
            api.category.index().then(
                response => commit('setCategories', response.data.data)
            )
        },
    },
    mutations: {
        setParcels(state, parcels) {
            state.parcels = parcels;
        },
        setCategories(state, categories) {
            state.categories = categories;
        },
        setWeight(state, weight) {
            state.weight = weight;
        },
        setHeight(state, height) {
            state.height = height;
        },
        setWidth(state, width) {
            state.width = width;
        },
        setLength(state, length) {
            state.length = length;
        },
        setSubcategory(state, subcategory) {
            state.subcategory = subcategory;
        },
        setDescription(state, description) {
            state.description = description;
        },
    },
}
